import { z } from "zod";

import { branded } from "@/lib/helpers/branded-helper";
import { heatPumpBrandDtoSchema } from "@/types/backoffice/dto/heatpump/heatpump-brand-dto.ts";

export enum EHeatPumpModelStatus {
  NOT_VALIDATED = "NOT_VALIDATED",
  VALIDATED_NOT_ELIGIBLE = "VALIDATED_NOT_ELIGIBLE",
  VALIDATED_ELIGIBLE = "VALIDATED_ELIGIBLE",
}

export const heatPumpModelStatusSchema = z.nativeEnum(EHeatPumpModelStatus);

export const heatPumpModelDtoSchema = z.object({
  id: branded.heatPumpModelId,
  model: z.string(),
  modopFilePath: z.string().nullable(),
  status: heatPumpModelStatusSchema,
  brand: heatPumpBrandDtoSchema.required(),
});

export type THeatPumpModelDto = z.infer<typeof heatPumpModelDtoSchema>;
